import React from 'react';
import { Typography, Card } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import InquirySection from '../components/InquirySection';

const { Title, Text } = Typography;

const InquiryPage: React.FC = () => (
  <div>
    <div style={{ marginBottom: 10 }}>
      <Title level={4} style={{ margin: 0, color: '#92400e' }}>
        <MessageOutlined style={{ marginRight: 8 }} />
        문의 / 요청
      </Title>
      <Text type="secondary">시험일정에 대한 문의·요청을 등록하고 담당자 답변을 확인하세요</Text>
    </div>

    <Card size="small">
      <InquirySection bare />
    </Card>
  </div>
);

export default InquiryPage;
